<template>
  <v-container class="qr-generator-container d-flex align-center justify-center">
    <v-card dark class="qr-card pa-5 text-center" width="450">
      <v-card-title class="justify-center text-h5 font-weight-bold">QR-Code Generator</v-card-title>
      <v-card-subtitle class="white--text pt-2"> Gib eine URL ein, um einen QR-Code zu erstellen. </v-card-subtitle>

      <v-text-field
        dark
        filled
        rounded
        dense
        label="Link oder Text für QR-Code"
        v-model="link"
        class="mx-4 mt-4"
        hide-details
        prepend-inner-icon="mdi-link"></v-text-field>

      <div class="qr-code-display my-5 pa-4">
        <v-img v-if="link" width="250px" class="mx-auto" :src="'/api/qrcode/image?data=' + encodedLink"></v-img>
        <div v-else class="placeholder-box d-flex align-center justify-center">
          <v-icon size="80" color="grey lighten-1">mdi-qrcode</v-icon>
        </div>
      </div>

      <v-btn color="primary" class="white--text" @click="downloadQRCode(link)" :disabled="!link" x-large block>
        <v-icon left>mdi-download</v-icon>
        QR-Code herunterladen
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import api from "../../../api"

export default {
  data() {
    return {
      link: "https://app.wellcomefit.ch",
    }
  },
  computed: {
    // Kodiert den Link, um sicherzustellen, dass die URL korrekt übergeben wird
    encodedLink() {
      return encodeURIComponent(this.link)
    },
  },
  methods: {
    async downloadQRCode(link) {
      // Die API-Methode wird aufgerufen, der Download wird vom Browser gehandhabt
      api.fetchQRCode(link)
    },
  },
}
</script>

<style lang="scss" scoped>
.qr-generator-container {
  min-height: 70vh;
}

.qr-card {
  border-radius: 16px !important;
  background: linear-gradient(145deg, #2a2a2a, #1e1e1e);
  box-shadow: 8px 8px 20px #1c1c1c, -8px -8px 20px #2e2e2e;
}

.qr-code-display {
  background-color: white;
  border-radius: 8px;
  display: inline-block;
}

.placeholder-box {
  width: 250px;
  height: 250px;
  background-color: #f0f0f0;
  border-radius: 8px;
}
</style>
